/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { markdown } from 'markdown';
import { MarkdownProps } from './types';
import { classnames } from 'helpers/utils/classnames';
import { sanitize } from 'dompurify';

const Markdown = ({ children, className }: MarkdownProps) => {
  const html = markdown.toHTML(children ?? '');

  const dangerousHtml = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

  const sanitizedHtml = sanitize(dangerousHtml);

  return (
    <p className={classnames('whitespace-pre-wrap', className)} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  );
};

export default Markdown;